import Tile, { TileType } from '@app/shared/components/tile/Tile';
import { InstrumentType } from '@app/shared/models/contracts/enums/shared-enums';
import { FC } from 'react';
import { useDrag } from 'react-dnd';
import styles from './instrument-tile.module.scss';
import classNames from 'classnames';
import { Tooltip, TooltipPlacement } from '@app/shared/components/tooltip/Tooltip';
import { useLocale } from '@app/core/hooks/useLocale';
import { MAX_INSTRUMENT_COUNT } from '@app/shared/constants/capital-structure';

interface InstrumentTileProps {
  instrumentType: InstrumentType;
  isDisabled: boolean;
  isErfModal?: boolean;
  haveHitMaxInstruments: boolean;
}

const InstrumentTypeToTileType = {
  [InstrumentType.ShareholderLoanNotes]: TileType.ShareholderLoans,
  [InstrumentType.PreferredShares]: TileType.PreferenceShares,
  [InstrumentType.OrdinaryEquity]: TileType.OrdinaryEquity,
};
export const PARENT_CLASSNAME = 'instrument-tile';
const InstrumentTileErf: FC<InstrumentTileProps> = ({
  instrumentType,
  isDisabled,
  isErfModal,
  haveHitMaxInstruments,
}): JSX.Element => {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: instrumentType,
      collect: (monitor) => ({
        isDragging: Boolean(monitor.isDragging()),
      }),
      canDrag: (_) => !isDisabled,
    }),
    [isDisabled]
  );

  const { l } = useLocale();

  const tooltipContent = haveHitMaxInstruments
    ? l('_NumberOfInstrumentsIsLimitedToMaxInstrumentCount', {
        maxInstrumentCount: MAX_INSTRUMENT_COUNT,
      })
    : undefined;

  return (
    <>
      <Tooltip
        content={tooltipContent}
        placement={TooltipPlacement.Bottom}
        useFixedPositioning
        shouldTooltipRender={haveHitMaxInstruments}
        contentTooltipClassName={isErfModal ? styles['modal-tooltip-zindex'] : undefined}>
        <div ref={drag} data-testid="instrument-tile" className={styles['wrapper']}>
          <div
            className={classNames(styles[`${PARENT_CLASSNAME}`], {
              [styles[`${PARENT_CLASSNAME}--hidden`]]: isDragging,
            })}>
            <Tile
              type={InstrumentTypeToTileType[instrumentType]}
              text={instrumentType}
              isDragEffectActive={isDragging}
              isDisabled={isDisabled}
              isErfModal={isErfModal}
            />
          </div>
        </div>
      </Tooltip>
    </>
  );
};

export default InstrumentTileErf;
